import { createBrowserRouter, RouteObject } from "react-router-dom";
import baseRoutes from "../../Routes/BaseRoute";
import partnerRoutes from "@/Routes/PartnerRoutes";
import journeyRoutes from "@/Routes/JourneyRoutes";

function getRoutes(): RouteObject[] {
  switch (import.meta.env.VITE_USER) {
    case "partner":
      return partnerRoutes;
    default:
      return baseRoutes;
  }
}
// Expose the current Git commit hash for build/version tracking
console.log("Build Hash:", __COMMIT_HASH__);
const globalRouterConfig = createBrowserRouter(
  [
    {
      path: "/",
      children: getRoutes(),
    },
    {
      path: "/journey",
      children: journeyRoutes,
    },
  ],
  { basename: import.meta.env.BASE_URL || "/" }
);

export default globalRouterConfig;
